import { Component } from "react";

import { withTranslation } from "react-i18next";
import type { WithTranslation } from "react-i18next";

import { MessageSquareIcon } from "@lucide/icons";

import { OpenAPI } from "simplydo/interfaces";
import { GiphyGif } from "simplydo/react/components/Giphy/Gif";
import { useTheme } from "simplydo/react/theme";
import { Icon } from "simplydo/react/ui/icon";

import FormattedComment from "components/lib/FormattedComment";

import type {
  FeedCardSharedProps,
  FeedChallengeIdeaCommentItem,
  FeedCommentMediaItem,
} from "../types";
import FeedCard from "./FeedCard";

type CardLeftProps = { comment: FeedChallengeIdeaCommentItem };

const CardLeft = ({ comment }: CardLeftProps) => {
  const hasComment = !!comment.comment;
  const hasMedia = comment.media?.length;
  const firstMediaItem: FeedCommentMediaItem =
    hasMedia && comment.media ? (comment.media[0] ?? {}) : {};
  const firstMediaItemIsImage =
    firstMediaItem.type === "gif" || firstMediaItem.type === "image";
  const firstMediaIsGif = firstMediaItem.type === "gif";
  const theme = useTheme();
  return (
    <div className="comment-column">
      <div className="comment-column-container">
        <Icon
          style={{
            color: theme.primaryColour,
            marginRight: 15,
            fontSize: "3em",
          }}
          icon={MessageSquareIcon}
          size="large"
        />
        {!hasComment && hasMedia && firstMediaItemIsImage ? (
          firstMediaIsGif ? (
            <GiphyGif gif={firstMediaItem.data} size="fixed" />
          ) : (
            <img
              style={{ borderRadius: 5, objectFit: "contain", maxHeight: 150 }}
              alt={firstMediaItem.value}
              src={firstMediaItem.signedDownloadRequest || firstMediaItem.value}
            />
          )
        ) : null}
        {hasComment ? (
          <p style={{ maxHeight: "100%", color: "#5d5d5d" }}>
            <FormattedComment noLink>
              &quot;
              {comment.comment}
              &quot;
            </FormattedComment>
          </p>
        ) : null}
      </div>
    </div>
  );
};

type ChallengeIdeaCommentCardProps = FeedCardSharedProps &
  WithTranslation & {
    comment: FeedChallengeIdeaCommentItem;
    profileFeed?: boolean;
    profileUser?: OpenAPI.Schemas["PreparedUser"];
    setIdeaPreviewId?: (ideaId: string) => void;
  };

class ChallengeIdeaCommentCard extends Component<ChallengeIdeaCommentCardProps> {
  render() {
    const { comment, hideAction, feedType, setIdeaPreviewId } = this.props;
    return (
      <FeedCard
        user={comment.owner}
        action="activityFeed.challengeComment.action"
        feedType={feedType}
        subjectItem={comment.idea.name}
        subjectItem2={comment.ownerChallenge?.name}
        date={comment.createdAt}
        type="COMMENT"
        cardContent={<CardLeft comment={comment} />}
        hideAction={hideAction}
        setIdeaPreviewId={setIdeaPreviewId}
        ideaId={comment.idea._id}
        commentId={comment._id}
      />
    );
  }
}

export default withTranslation()(ChallengeIdeaCommentCard);
